/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FacilitySearchRequest } from '../models/facility-search-request';
import { KEngineResponseContainerFacilityResponseOfMasteredLocations } from '../models/k-engine-response-container-facility-response-of-mastered-locations';
import { KEngineResponseContainerFacilityResponseOfOrgAffiliations } from '../models/k-engine-response-container-facility-response-of-org-affiliations';
import { MultiTenantOrganizationSearchRequestV2 } from '../models/multi-tenant-organization-search-request-v-2';

@Injectable({
  providedIn: 'root',
})
export class FacilitySearchService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation multiTenantFacilitySearchV2CareFindr
   */
  static readonly MultiTenantFacilitySearchV2CareFindrPath = '/v3/facility/search-carefindr';

  /**
   * Multi-tenant facility search.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantFacilitySearchV2CareFindr()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantFacilitySearchV2CareFindr$Response(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Two Stroke Facility Request. See design: https://leaporbit.atlassian.net/wiki/spaces/CONVERGENT/pages/53739533/Two-stroke+Design
     */
    body: FacilitySearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerFacilityResponseOfOrgAffiliations>> {

    const rb = new RequestBuilder(this.rootUrl, FacilitySearchService.MultiTenantFacilitySearchV2CareFindrPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerFacilityResponseOfOrgAffiliations>;
      })
    );
  }

  /**
   * Multi-tenant facility search.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantFacilitySearchV2CareFindr$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantFacilitySearchV2CareFindr(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Two Stroke Facility Request. See design: https://leaporbit.atlassian.net/wiki/spaces/CONVERGENT/pages/53739533/Two-stroke+Design
     */
    body: FacilitySearchRequest
  },
  context?: HttpContext

): Observable<KEngineResponseContainerFacilityResponseOfOrgAffiliations> {

    return this.multiTenantFacilitySearchV2CareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerFacilityResponseOfOrgAffiliations>) => r.body as KEngineResponseContainerFacilityResponseOfOrgAffiliations)
    );
  }

  /**
   * Path part for operation multiTenantFacilityDetailCareFindr
   */
  static readonly MultiTenantFacilityDetailCareFindrPath = '/v3/carefindr/facility/{uid}';

  /**
   * Multi-tenant facility detail.
   *
   * This interface is invoked when the user clicks on the name of the facility on the facility results page, in order to fetch additional information<br/>such as facility type, all the languages spoken, etc,by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantFacilityDetailCareFindr()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantFacilityDetailCareFindr$Response(params: {

    /**
     * Unique ID assigned to the facility.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerFacilityResponseOfMasteredLocations>> {

    const rb = new RequestBuilder(this.rootUrl, FacilitySearchService.MultiTenantFacilityDetailCareFindrPath, 'get');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.header('x-user-id', params['x-user-id'], {});
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.query('explain', params.explain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerFacilityResponseOfMasteredLocations>;
      })
    );
  }

  /**
   * Multi-tenant facility detail.
   *
   * This interface is invoked when the user clicks on the name of the facility on the facility results page, in order to fetch additional information<br/>such as facility type, all the languages spoken, etc,by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantFacilityDetailCareFindr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantFacilityDetailCareFindr(params: {

    /**
     * Unique ID assigned to the facility.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<KEngineResponseContainerFacilityResponseOfMasteredLocations> {

    return this.multiTenantFacilityDetailCareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerFacilityResponseOfMasteredLocations>) => r.body as KEngineResponseContainerFacilityResponseOfMasteredLocations)
    );
  }

  /**
   * Path part for operation facilitySearchCarefindrV3
   */
  static readonly FacilitySearchCarefindrV3Path = '/facility/search';

  /**
   * Facility search (CareFindr V3).
   *
   * Searches for facilities in the provider network. CareFindr V3 route.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilitySearchCarefindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  facilitySearchCarefindrV3$Response(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * The query payload for facility search
     */
    body?: MultiTenantOrganizationSearchRequestV2
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerFacilityResponseOfOrgAffiliations>> {

    const rb = new RequestBuilder(this.rootUrl, FacilitySearchService.FacilitySearchCarefindrV3Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerFacilityResponseOfOrgAffiliations>;
      })
    );
  }

  /**
   * Facility search (CareFindr V3).
   *
   * Searches for facilities in the provider network. CareFindr V3 route.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilitySearchCarefindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  facilitySearchCarefindrV3(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * The query payload for facility search
     */
    body?: MultiTenantOrganizationSearchRequestV2
  },
  context?: HttpContext

): Observable<KEngineResponseContainerFacilityResponseOfOrgAffiliations> {

    return this.facilitySearchCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerFacilityResponseOfOrgAffiliations>) => r.body as KEngineResponseContainerFacilityResponseOfOrgAffiliations)
    );
  }

  /**
   * Path part for operation facilityDetailCarefindrV3
   */
  static readonly FacilityDetailCarefindrV3Path = '/facility/search/{uid}';

  /**
   * Facility detail (CareFindr V3).
   *
   * Fetches detailed facility information. CareFindr V3 route.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityDetailCarefindrV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityDetailCarefindrV3$Response(params: {

    /**
     * Unique ID assigned to the facility.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent.
     */
    'x-user-id'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerFacilityResponseOfMasteredLocations>> {

    const rb = new RequestBuilder(this.rootUrl, FacilitySearchService.FacilityDetailCarefindrV3Path, 'get');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.header('x-user-id', params['x-user-id'], {});
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.query('explain', params.explain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerFacilityResponseOfMasteredLocations>;
      })
    );
  }

  /**
   * Facility detail (CareFindr V3).
   *
   * Fetches detailed facility information. CareFindr V3 route.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityDetailCarefindrV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityDetailCarefindrV3(params: {

    /**
     * Unique ID assigned to the facility.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent.
     */
    'x-user-id'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<KEngineResponseContainerFacilityResponseOfMasteredLocations> {

    return this.facilityDetailCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerFacilityResponseOfMasteredLocations>) => r.body as KEngineResponseContainerFacilityResponseOfMasteredLocations)
    );
  }

}
